module.exports = __webpack_public_path__ + "static/media/Camila_Esvaziando.7ed5bdc4.png";